"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPaginatedEndpoint = exports.createPaginatedEndpointFactory = void 0;
var Endpoint_1 = require("./Endpoint");
function createPaginatedEndpointFactory(factory) {
    return factory;
}
exports.createPaginatedEndpointFactory = createPaginatedEndpointFactory;
function createPaginatedEndpoint(endpoint) {
    if (!endpoint.method) {
        endpoint.method = 'get';
    }
    if (!endpoint.bodyType) {
        endpoint.bodyType = Endpoint_1.EndpointBodyType.PROPERTY;
    }
    return endpoint;
}
exports.createPaginatedEndpoint = createPaginatedEndpoint;
